import React from "react";

const Dashboard = () => {
  // Sample data for the cards
  const userData = [
    { label: "Total Users", count: 40689 },
    { label: "Total Lawyers", count: 10293 },
    { label: "Total Students", count: 89000 },
    { label: "Total Clients", count: 2040 },
  ];

  return (
    <div
      style={{
        backgroundColor: "#F5F6FA",
        border: "1px solid transparent", // Changed to 'solid' for better consistency
        height: "100vh",
        width: "100%",
        overflowX: "auto",
        overflowY: "auto",
        padding: "20px",
      }}
    >
      <h2 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "20px" }}>
        Active Users
      </h2>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          flexWrap: "nowrap",
          gap: "20px",
          overflowX: "auto",
        }}
      >
        {userData.map((user, index) => (
          <div
            key={index} // Use index as key; ideally use a unique ID if available
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              minWidth: "200px",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              flexShrink: 0,
              transition: "transform 0.2s", // Smooth hover effect
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)"; // Scale up on hover
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)"; // Scale back on mouse leave
            }}
          >
            {user.label}: {user.count.toLocaleString()} {/* Format count with commas */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
